import type { IconSvgObject } from './types';

const StrikethroughIcon: IconSvgObject = [
  ["path", { d: "M3.99219 12H19.9922", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.4922 7.66667C17.4922 5.08934 15.0298 3 11.9922 3C8.95462 3 6.49219 5.08934 6.49219 7.66667C6.49219 8.15279 6.54555 8.59783 6.65899 9M5.99219 16.3333C5.99219 18.9107 8.67848 21 11.9922 21C15.3059 21 17.9922 19.6667 17.9922 16.3333C17.9922 13.9404 16.9615 12.5782 14.9001 12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default StrikethroughIcon;
